export type AuthErrorChannel = 'telegram' | 'email'

export function formatAuthErrorMessage(rawError: unknown, channel: AuthErrorChannel): string {
  const rawMessage = rawError instanceof Error ? rawError.message : 'Unknown error'

  if (rawMessage === 'invite_email_link_expired') {
    return 'Срок действия ссылки истёк. Укажите email, чтобы получить новую ссылку.'
  }

  // Ссылка из письма живёт 15 минут (EMAIL_TOKEN_TTL_MS в edge-функции auth) и привязана к
  // моменту отправки. Английский текст сервера человеку ничего не объяснял: за 14 дней до
  // 20.08.2026 в него уперлись 161 раз при 91 успешном входе.
  if (rawMessage === 'Invalid or expired email token') {
    return 'Ссылка для входа устарела. Она действует 15 минут с момента отправки — запросите новую ссылку на этой странице и откройте её сразу.'
  }

  if (rawMessage === 'invite_required') {
    if (channel === 'telegram') {
      return 'Для входа через Telegram этот аккаунт еще не привязан как способ входа. Если вы входите впервые, получите ссылку для входа в управляющей компании. Или войдите по email и добавьте Telegram как альтернативный канал.'
    }

    return 'Для входа через email этот адрес еще не привязан как способ входа. Если вы входите впервые, получите ссылку для входа по почте. Или войдите через Telegram и добавьте email как альтернативный канал.'
  }

  if (rawMessage === 'invite_email_mismatch') {
    return 'Это приглашение создано для другого email. Введите адрес, который указал создатель приглашения.'
  }

  if (rawMessage === 'invite_email_required') {
    return 'Это персональное приглашение нужно принять через email. Введите адрес, который указал создатель приглашения.'
  }

  if (channel === 'telegram') {
    return `Ошибка аутентификации: ${rawMessage}`
  }

  return `Ошибка входа по email: ${rawMessage}`
}
